
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Les erreurs courantes à éviter en campagne Google Ads",
    description:
      "Découvrez les erreurs fréquentes en création de campagnes Google Ads et comment les éviter pour maximiser votre succès, grâce aux conseils d'experts d'ALEO.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
